/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ocr_Language_LabelInputs */

const en_ocr_language_label = /** @type {(inputs: Ocr_Language_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`OCR Language`)
};

const fr_ocr_language_label = /** @type {(inputs: Ocr_Language_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Langue OCR`)
};

const de_ocr_language_label = /** @type {(inputs: Ocr_Language_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`OCR-Sprache`)
};

const it_ocr_language_label = /** @type {(inputs: Ocr_Language_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lingua OCR`)
};

const ru_ocr_language_label = /** @type {(inputs: Ocr_Language_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Язык OCR`)
};

const es_ocr_language_label = /** @type {(inputs: Ocr_Language_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Idioma OCR`)
};

const zh_cn2_ocr_language_label = /** @type {(inputs: Ocr_Language_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`OCR语言`)
};

const ja_ocr_language_label = /** @type {(inputs: Ocr_Language_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`OCR言語`)
};

const hi_ocr_language_label = /** @type {(inputs: Ocr_Language_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ओसीआर भाषा`)
};

const pt_pt2_ocr_language_label = /** @type {(inputs: Ocr_Language_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Idioma OCR`)
};

/**
* | output |
* | --- |
* | "OCR Language" |
*
* @param {Ocr_Language_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const ocr_language_label = /** @type {((inputs?: Ocr_Language_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ocr_Language_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_ocr_language_label(inputs)
	if (locale === "de") return de_ocr_language_label(inputs)
	if (locale === "it") return it_ocr_language_label(inputs)
	if (locale === "ru") return ru_ocr_language_label(inputs)
	if (locale === "es") return es_ocr_language_label(inputs)
	if (locale === "zh-CN") return zh_cn2_ocr_language_label(inputs)
	if (locale === "ja") return ja_ocr_language_label(inputs)
	if (locale === "hi") return hi_ocr_language_label(inputs)
	if (locale === "pt-PT") return pt_pt2_ocr_language_label(inputs)
	return en_ocr_language_label(inputs)
});